import React from 'react'
import { connect } from 'react-redux'
import PaymentModal from '../components/payment-modal'

const mapStateToProps = ({currentReservation: {payment}, currentShop, entities: {products}}) => ({
  reservationPayment: payment,
  shop: currentShop,
  products,
})

const mapDispatchToProps = dispatch => ({
  loadData: payload => dispatch({type: 'PAYMENT_MODAL.LOAD_DATA', payload}),
  clearData: payload => dispatch({type: 'PAYMENT_MODAL.CLEAR_DATA'}),
  clearAlert: () => dispatch({type: 'PAYMENT_MODAL.CLEAR_ALERT'}),
  expandProducts: () => dispatch({type: 'PAYMENT_MODAL_EXPAND_PRODUCTS'}),
  collapseProducts: () => dispatch({type: 'PAYMENT_MODAL_COLLAPSE_PRODUCTS'}),
  toggleCart: () => dispatch({type: 'PAYMENT_MODAL_TOGGLE_CART'}),
  handleTouchless: () => dispatch({ type: 'PAY_TOUCHLESS'}),
  closeQr: () => dispatch({ type: 'ORDER.TOUCHLESS_ORDER_CLOSED' }),
  onTouchlessSuccess: payload => dispatch({ type: 'PAYMENT_MODAL.TOUCHLESS_SUCCESS', payload }),
  changePlayer: payload => dispatch({type: 'PAYMENT_MODAL_PLAYER_CHANGED', payload}),
  handleCardNumber: payload => dispatch({type: 'CARD_NUMBER_PAYMENT_METHOD_RECEIVED', payload}),
  updateCards: payload => dispatch({type: 'PAYMENT_MODAL.UPDATE_CARDS', payload}),
  submitOrder: payload => dispatch({type: 'SUBMIT_ORDER', payload}),
  startLoading: () => dispatch({type: 'PAYMENT_MODAL.START_LOADING'}),
  onM2Connection: (payload) => dispatch({type: 'M2.CONNECTION', payload}),
  onM2Payment: (payload) => dispatch({type: 'M2.PAYMENT', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(PaymentModal)
